<template>
  <element>
    <AppBar :title="title" />

    <div class="full-screen-underlay">
      <div class="camera-frame">
        <img class="corner-top-left" src="../assets/camera-frame-corner.svg">
        <img class="corner-top-right" src="../assets/camera-frame-corner.svg">
        <img class="corner-bottom-left" src="../assets/camera-frame-corner.svg">
        <img class="corner-bottom-right" src="../assets/camera-frame-corner.svg">
      </div>
      <div class="top-linear-gradient"></div>
      <qrcode-stream @decode="onDecode" @init="onInit"></qrcode-stream>        
      <div class="bottom-linear-gradient"></div>
    </div>

    <v-container class="pl-0 pr-0 pt-0 pb-0" fluid>
      <v-row no-gutters class="first-line  d-none">
        <v-spacer>
        </v-spacer>
        <v-col class="col-5">
          <v-switch 
          v-model="auto_scan"
          class="v-input--reverse"
          color="orange-darken-3"
          inset
          dark
          >
            <template #label>
              Auto-scan
            </template>
          </v-switch>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-4 align-center justify-content-center second-line">
        <v-spacer>
        </v-spacer>
        <v-col class="position-relative col-10 col-sm-5 col-md-5 col-lg-5">
          <p class="scanned-position mb-0"> 
            <v-icon  large color="purple">
              mdi-map-marker
            </v-icon>  
            {{ this.decodedWarehouseLocation }} 
          </p>
        </v-col>
        <v-spacer>
        </v-spacer>
      </v-row>
      <v-row no-gutters class="pt-0 mt-0">
        <v-col class="col-12">
          <p class="scan-error-message" v-if="isLocationInvalid">{{ $t('scanWareouseLocation.scan_error') }}</p>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-4 align-center justify-content-center">
        <v-col class="position-relative">

        </v-col>
      </v-row>
    </v-container>
    <div class="action-buttons-bottom">
      <v-btn
      class="mx-2"
      fab
      dark
      x-large
      :disabled="isLocationInvalid"
      color="green"
      @click="complete"
    >
      <v-icon dark>
        mdi-checkbox-marked-circle-outline
      </v-icon>
    </v-btn>
    </div>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue";
import { QrcodeStream  } from 'vue-qrcode-reader';

export default {
  name: "ScanWarehouseLocationPage",
  components: {
    AppBar,
    QrcodeStream ,
  },
  data () {
    return {
      auto_scan: false,
      decodedWarehouseLocation: null,
      qrcodeJson:null,
      isLocationInvalid: true,
    }
  },
  props: {

  },
  created(){
    this.title = this.$store.getters.getCurrentTask.taskName;

  },
  methods: {
    onDecode (decodedString) {
      let qrcode=null
      this.qrcodeJson = null
      try {
        qrcode = JSON.parse(decodedString);
        this.qrcodeJson = decodedString
      } catch(e) {
        console.log('scanned qr code is not a json string', decodedString)
        this.isLocationInvalid = true
        this.decodedWarehouseLocation=''
        this.qrcodeJson = null
      }
      if (qrcode)
      {
        // we validate the json object
        if (this.validateLocation(qrcode, 'warehouse'))
        {
          this.decodedWarehouseLocation = qrcode.location.aisle + '-' + qrcode.location.unit + '-' + qrcode.location.shelf + '-' + qrcode.location.bin
        }
      }
    },

    validateLocation(qrcode, type='warehouse')
    {
      if (typeof qrcode.location ==undefined || typeof qrcode.type ==undefined)
      {
        this.isLocationInvalid = true
        return false
      }

      if (qrcode.type == type)
      {
        this.isLocationInvalid = false
        return true
      } else {
        this.isLocationInvalid = true
        return false
      }
    },

    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        console.log(error)
      }
    },
    complete() {
      const variables = {
        "variables": {
          "warehouse_location": {
            "value": this.qrcodeJson,
            "type": "String"
          }
        }
      }
      
      const taskId = this.$store.getters.getCurrentTask?.id

      if (taskId) {
        this.$store.dispatch('completeTask', { taskId, variables })
        .then(response => {
          console.log("Task completed successfully!", taskId, response)
        })
        .catch(error => {
          console.log("Failed completing task!", taskId, error)
        })
      }
    },
  }
}
</script>

<style scoped>
.full-screen-underlay {
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 0;
    background-color: black; 
  }

.scanned-position {
    background-color: #616161d6;
    color: white;
    border: 1px solid #FFFFFF;
    box-sizing: border-box;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    font-family: Rubik;
    font-size: 40px;
}

.v-input--reverse .v-input__slot {
  flex-direction: row-reverse;
  justify-content: flex-end;
  color: white !important;
}

.v-icon {
  color: white !important;
  vertical-align: inherit;
}

.v-btn--fab.v-size--x-large .v-icon {
  font-size: 50px;
}

.scan-error-message {
  color: red;
}

.top-linear-gradient {
  /* Black gradient mask (top) */
    position: absolute;
    width: 100vw;
    height: 350px;
    left: 0px;
    top: 0px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.8) 38%, rgba(0, 0, 0, 0) 93%);
    z-index: 1;
}

.bottom-linear-gradient {
  /* Black gradient mask (bottom) */
  position: absolute;
  width: 100vw;
  height: 250px;
  left: 0px;
  bottom: 0px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.8) 18%, rgba(0, 0, 0, 0) 80%);
  transform: matrix(1, 0, 0, -1, 0, 0);
}

.action-buttons-bottom {
  position: absolute;
  bottom: 0px;
  text-align: center;
  width: 100vw;
  margin-bottom:20px;
}

.theme--dark.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: green;
}

.camera-frame {
    position: absolute;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 999;
    opacity: 0.7;
}

.camera-frame > .corner-top-left {
    position: absolute;
    float: left;
    left: 10%;
    top: 30%;
}

.camera-frame > .corner-top-right {
    position: absolute;
    float: right;
    right: 15%;
    top: 30%;
    transform: rotate(90deg);
}

.camera-frame > .corner-bottom-left {
    position: absolute;
    float: left;
    left: 10%;
    top: 80%;
    transform: rotate(-90deg);
}

.camera-frame > .corner-bottom-right {
    position: relative;
    float: right;
    right: 15%;
    top: 80%;
    transform: rotate(180deg);
}
</style>

<style>
/* td #139 fixes the blurred video stream */
/* the app .overlay conflicts with the vue-qrcode-viewer overlay class */
/* #208 https://github.com/gruhn/vue-qrcode-reader/issues/208 */
.overlay {
  -webkit-backdrop-filter: blur(0px) !important;
  backdrop-filter: blur(0px) !important;
  background: transparent !important;
}
</style>